export const provinces = [
  { value: '1', text: 'San José' },
  { value: '2', text: 'Alajuela' },
  { value: '3', text: 'Cartago' },
  { value: '4', text: 'Heredia' },
  { value: '5', text: 'Guanacaste' },
  { value: '6', text: 'Puntarenas' },
  { value: '7', text: 'Limón' }
]
